import { TabbedItemPage } from './TabbedItemPage';

export const WorkerRecordPage = () => <TabbedItemPage itemPath="/workers/worker-record" />;
